import { render, staticRenderFns } from "./QuotaItem.vue?vue&type=template&id=6f60bff6&scoped=true&"
import script from "./QuotaItem.vue?vue&type=script&lang=js&"
export * from "./QuotaItem.vue?vue&type=script&lang=js&"
import style0 from "./QuotaItem.vue?vue&type=style&index=0&id=6f60bff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60bff6",
  null
  
)

export default component.exports